export const CouponStatus = {
  APPLIED: 0,
  INVALID: 1,
  NOT_SELECTED: 2,
  LESS_THAN_RENEW_DISCOUNT: 3,
  eq: (a, b) => a === b,
}
